import { NeutralColor } from "node-library/dist/colors";
import { FrontendOrganization } from "node-library/dist/portal";
import { useTranslation } from "react-i18next";
import ViewOrgsTable from "./viewOrgsTable";

interface Props {
	organizations: Array<FrontendOrganization>;
	goToViewOrgDetails: (org: FrontendOrganization) => void;
	setDeleteOrgConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function OrgssContent(props: Props) {
	const { t: translation } = useTranslation();

	const {
		organizations,
		goToViewOrgDetails,
		setDeleteOrgConfirmOpen,
		setProceedAction,
	} = props;

	return (
		<div style={{ flex: "1 1 0%", position: "relative" }}>
			{organizations.length === 0 ? (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%, -50%)",
						gap: "5px",
					}}
				>
					<div
						className="typography-heading-01"
						style={{ marginTop: "20px", color: NeutralColor.NEUTRAL_GREY_300 }}
					>
						{translation("NoOrganizations")}
					</div>
				</div>
			) : (
				<div>
					<ViewOrgsTable
						organizations={organizations}
						goToViewOrgDetails={goToViewOrgDetails}
						setDeleteOrgConfirmOpen={setDeleteOrgConfirmOpen}
						setProceedAction={setProceedAction}
					/>
				</div>
			)}
		</div>
	);
}
